import {
  BookOpen,
  BrainCircuit,
  Building2,
  ClipboardCheck,
  Cloud,
  Ear,
  FlaskConical,
  Gavel,
  GraduationCap,
  Handshake,
  HeartHandshake,
  Megaphone,
  Mic,
  Plane,
  RefreshCw,
  Scale,
  Scissors,
  Server,
  ShieldCheck,
  Sparkles,
  UserPlus,
  Users,
  Zap,
  type LucideIcon,
} from 'lucide-react'

export const ACTIVITY_ICONS: Record<string, LucideIcon> = {
  // Technology & Capability
  T1: Server,
  T2: Cloud,
  T3: Building2,
  T4: BrainCircuit,
  // Innovation & Deployment
  I1_SMALL: FlaskConical,
  I1_MEDIUM: FlaskConical,
  I1_LARGE: FlaskConical,
  I2: Zap,
  I3: Sparkles,
  I4: Scissors,
  I5: RefreshCw,
  // People & Skills
  P1: BookOpen,
  P2: GraduationCap,
  P3: Plane,
  P4: UserPlus,
  P5: Users,
  // Change Management
  C1: HeartHandshake,
  C2: Megaphone,
  C3: Ear,
  C4: Mic,
  C5: Handshake,
  // Governance & Risk
  G1: Scale,
  G2: ClipboardCheck,
  G3: ShieldCheck,
  G4: Gavel,
}
